import api from "../api"; // Importa o axios configurado

/**
 * Envia uma mensagem no chat interno
 * @param {Object} dadosMensagem - Dados da mensagem
 * @param {number} [dadosMensagem.remetente_id] - ID de quem envia a mensagem (fixo ou dinâmico)
 * @param {number} dadosMensagem.destinatario_id - ID de quem recebe a mensagem
 * @param {string} dadosMensagem.mensagem - Conteúdo da mensagem
 * @returns {Promise<Object>} - Resposta do backend
 */
export async function enviarMensagem(dadosMensagem) {
  try {
    const payload = {
      remetente_id: dadosMensagem.remetente_id || 1, // ID fixo se não estiver logado
      destinatario_id: dadosMensagem.destinatario_id,
      mensagem: dadosMensagem.mensagem,
    };

    const response = await api.post("/chat-interno/enviar.php", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao enviar mensagem:", error);
    if (error.response?.data) throw error.response.data;
    throw new Error("Erro ao conectar com o servidor.");
  }
}

/**
 * Lista todas as mensagens trocadas entre dois usuários (bidirecional)
 * @param {number} remetente_id - ID do usuário logado
 * @param {number} destinatario_id - ID do outro usuário
 * @returns {Promise<Array>} - Lista de mensagens
 */
export async function listarMensagens(remetente_id, destinatario_id) {
  try {
    const response = await api.get("/chat-interno/listar.php", {
      params: { remetente_id, destinatario_id },
    });

    // Garante retorno padronizado
    if (response.data?.status === "sucesso" && Array.isArray(response.data.dados)) {
      return response.data.dados;
    }

    return [];
  } catch (error) {
    console.error("Erro ao listar mensagens:", error);
    return [];
  }
}
